export interface ICashbackClaimSummaryResources {
    purchaseLabel: string;
}

export const CashbackClaimSummaryResources: ICashbackClaimSummaryResources = {
    purchaseLabel: "Zakup: ",
};
